import './styles.css';
import SvgIcon, { iconList } from '../iconSVG';
function RequiredSession({ navigation }) {
  return (
    <div className='requiredSession'>
      <div className='requiredSessionIcon'>
        <SvgIcon color={'#004274'} name={iconList.IconUserCircleOutLine} size={130} />
      </div>
      <p className='requiredSessionTitle'>Debes iniciar sesion para continuar</p>
      <div className='requiredSessionPannel'>
        <div onClick={() => navigation('/login')} className='requiredSessionBtn'>
          <p className='requiredSessionBtnText'>
            Iniciar sesión
          </p>
        </div>
        <div onClick={() => navigation('/register')} className='requiredSessionBtn'>
          <p className='requiredSessionBtnText'>
            registrarme
          </p>
        </div>
      </div>
    </div>
  )
}
export default RequiredSession;
